import styled from "styled-components";

import { colors } from "const/colors";

const Outer = styled.section`
	width: 100%;
	background: ${({ $bg }) => $bg};
	padding: ${({ $pad }) => $pad};
	box-sizing: border-box;
	scroll-margin-top: 140px;
`;

export default function Band({ children, alt, plus, id, pad }) {
	const bg = plus ? "#ebe4f6" : alt ? "#fff" : colors.page;

	return (
		<Outer id={id} $bg={bg} $pad={pad || "80px 0"}>
			{children}
		</Outer>
	);
}
